<template>

  <p v-if="error" class="error">{{ error }}</p>
  <div class="cell small-12">
    <h1>Company Questionnaire</h1>
    <p>To help us get your company set up with our payroll services, we’ve put together a quick questionnaire for you to share your company details.</p>
    <p>For this this questionnaire you will require the following information:
      <ul>
        <li>Payroll Type</li>
        <li>PAYE Reference</li>
        <li>Accounts Office Reference</li>
        <li>Eligibility for Employment Allowance</li>
        <li>Liability for Apprenticeship Levy</li>
        <li>Eligibility for Small Employers Relief</li>
      </ul>
    </p>
  </div>


</template>


<script setup>

import { ref } from 'vue'

const error = ref(null)


const props = defineProps({
  formData: Object,
  clientInvite: Object
})


const validateStep = () => {
  return true;
}



const executeStep = async () => {
  return true;
}


defineExpose({ validateStep, executeStep });

</script>